import styled, { css } from "styled-components";

const buttonBase = css`
  background: transparent;
  border: 1px solid var(--color-bone);
  color: var(--color-bone);
  font-family: "Ysabeau";
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.13em;
  padding: 0.9rem 2.4rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  isolation: isolate;
  transition: color 1000ms cubic-bezier(0.4, 0, 0.2, 1);

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: var(--color-bone);
    transform: translateX(-100%);
    transition: transform 750ms cubic-bezier(0.4, 0, 0.2, 1);
    z-index: -1;
  }

  &::after {
    content: "";
    display: ${({ noLine }) => (noLine ? "none" : "block")};
    position: relative;
    z-index: 1;
    width: 1.5rem;
    height: 1px;
    background: var(--color-bone);
    flex-shrink: 0;
    transition: background 500ms cubic-bezier(0.4, 0, 0.2, 1);

    @media screen and (max-width: 600px) {
      display: none;
    }
  }

  &:hover {
    color: var(--color-obsidian);

    &::before {
      transform: translateX(0);
    }

    &::after {
      background: var(--color-obsidian);
    }
  }
`;

export const ButtonLabel = styled.span`
  position: relative;
  z-index: 1;
`;

export const PrimaryButton = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== "noLine",
})`
  ${buttonBase}

  & > * {
    position: relative;
    z-index: 1;
  }
`;

export const PrimaryButtonLink = styled.a.withConfig({
  shouldForwardProp: (prop) => prop !== "noLine",
})`
  ${buttonBase}
  text-decoration: none;
  isolation: isolate;

  &:visited {
    color: var(--color-bone);
  }

  &:hover:visited {
    color: var(--color-obsidian);
  }
`;

export const DisabledPrimaryButton = styled.span`
  ${buttonBase}
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: none;

  &:hover {
    color: var(--color-bone);

    &::before {
      transform: translateX(-100%);
    }

    &::after {
      background: var(--color-bone);
    }
  }
`;

export const EmphasisButton = styled.button`
  ${buttonBase}
  border-color: var(--color-emphasis);

  &::before {
    background: var(--color-emphasis);
  }

  &::after {
    background: var(--color-emphasis);
  }

  &:hover {
    color: var(--color-bone);

    &::after {
      background: var(--color-bone);
    }
  }
`;
